module.exports = __webpack_public_path__ + "img/oil-can.4826bf48.svg";